import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, ButtonToolbar } from 'react-bootstrap';
import { Field, reduxForm } from 'redux-form';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import formMessages from 'components/ReduxForm/messages';
import render from 'components/ReduxForm/renderField';
import layoutStyle from '../../styles/base/layout.scss'; // eslint-disable-line css-modules/no-unused-class
// eslint-disable-next-line css-modules/no-unused-class
import s from './Notifications.scss';
import validations from '../ReduxForm/validations';
import tableMessages from './messages';

const validate = values => {
  const errors = {};
  if (!validations.required(values.title)) {
    errors.title = <FormattedMessage {...formMessages.required} />;
  }
  if (!validations.required(values.message)) {
    errors.message = <FormattedMessage {...formMessages.required} />;
  }
  if (!validations.required(values.startDate)) {
    errors.startDate = <FormattedMessage {...formMessages.required} />;
  }
  if (!validations.required(values.startTime)) {
    errors.startTime = <FormattedMessage {...formMessages.required} />;
  }
  if (!validations.required(values.endDate)) {
    errors.endDate = <FormattedMessage {...formMessages.required} />;
  }
  if (!validations.required(values.endTime)) {
    errors.endTime = <FormattedMessage {...formMessages.required} />;
  }
  if (!validations.required(values.priority)) {
    errors.priority = <FormattedMessage {...formMessages.required} />;
  }
  return errors;
};

class EditNotificationForm extends React.Component {
  static propTypes = {
    submitting: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    errors: PropTypes.arrayOf(PropTypes.string),
    initialValues: PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      message: PropTypes.bool.isRequired,
      startTime: PropTypes.string.isRequired,
      endTime: PropTypes.string.isRequired,
      startDate: PropTypes.string.isRequired,
      endDate: PropTypes.string.isRequired,
      creator: PropTypes.string.isRequired,
    }),
  };

  static defaultProps = {
    errors: [],
    initialValues: {},
  };

  constructor(props) {
    super(props);
    this.prioritySelectRef = React.createRef();
  }

  render() {
    const { errors, initialValues } = this.props;
    return (
      <form onSubmit={this.props.handleSubmit}>
        <fieldset>
          <Row className={layoutStyle.noMargin}>
            <Col xs={6} md={4} style={{ paddingLeft: '0px' }}>
              <Field
                id="title"
                name="title"
                label={<FormattedMessage {...tableMessages.title} />}
                component={render.renderInput}
              />
            </Col>
            <Col xs={4} md={3} style={{ paddingLeft: '0px' }}>
              <Field
                id="priority"
                name="priority"
                label={<FormattedMessage {...tableMessages.priority} />}
                component={render.renderSelectAlt}
                options={[
                  { value: 'high', label: 'high' },
                  { value: 'medium', label: 'medium' },
                  { value: 'low', label: 'low' },
                ]}
                selectRef={this.prioritySelectRef}
              />
            </Col>
            <Col xs={12} md={12} style={{ paddingLeft: '0px' }}>
              {/* TODO: make it richtText input */}
              <Field
                id="message"
                name="message"
                label={<FormattedMessage {...tableMessages.message} />}
                component={render.renderInput}
              />
            </Col>
            <Col xs={12} md={3} style={{ paddingLeft: '0px' }}>
              <Field
                id="startDate"
                name="startDate"
                label={<FormattedMessage {...tableMessages.start} />}
                component={render.renderDate}
              />
              <Field
                id="startTime"
                name="startTime"
                component={render.renderTime}
                interval={15}
                initialValue={{ value: initialValues.startTime || null }}
                handleUpdate={() => {}}
              />
            </Col>
            <Col xs={12} md={3} style={{ paddingLeft: '0px' }}>
              <Field
                id="endDate"
                name="endDate"
                label={<FormattedMessage {...tableMessages.end} />}
                component={render.renderDate}
              />
              <Field
                id="endTime"
                name="endTime"
                component={render.renderTime}
                interval={15}
                initialValue={{ value: initialValues.endTime || null }}
                handleUpdate={() => {}}
              />
            </Col>
          </Row>
          <hr />
          {errors.length === 0 ? null : (
            <ul style={{ padding: '0', listStyleType: 'none' }}>
              {errors.map(err => (
                <li key={err} className="bg-danger">
                  {err}
                </li>
              ))}
            </ul>
          )}
          <hr />
          <ButtonToolbar>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={this.props.submitting}
            >
              <FormattedMessage {...formMessages.submit} />
            </button>
          </ButtonToolbar>
        </fieldset>
      </form>
    );
  }
}

export default reduxForm({
  form: 'notification-edit',
  validate,
  enableReinitialize: true,
})(injectIntl(withStyles(s, layoutStyle)(EditNotificationForm)));
